<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
<h1 class="page-header">Capital Component Usage</h1>
<br/>

@if (permission()) {
    <div class="alert alert-warning" role="alert">
        Capital queries can take up to {{ MAX_POLL_MINUTES }} minutes to complete.
        Do not close or refresh this page while a query is running.
    </div>

    <br/>

    <table class="files-input">
        <tr>
            <td>
                <label class="font-weight-bold">* Type</label><br/>
                <p-select
                    [options]="partTypes"
                    [(ngModel)]="selectedType"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select a type..."
                    [disabled]="isRunning"
                    styleClass="w-full"
                    >
                </p-select>
            </td>
        </tr>

        <!-- OCOCI: Object Code autocomplete + OC Instance text field -->
        @if (isOcOciType()) {
            <tr>
                <td>
                    <label class="font-weight-bold">* Object Code</label><br/>
                    <p-autoComplete
                        [(ngModel)]="selectedObjectCode"
                        [suggestions]="filteredObjectCodes"
                        (completeMethod)="searchObjectCodes($event)"
                        optionLabel="displayLabel"
                        [forceSelection]="true"
                        (onClear)="selectedObjectCode = null"
                        [disabled]="isRunning"
                        placeholder="Search object code..."
                        styleClass="w-full"
                        inputStyleClass="w-full">
                    </p-autoComplete>
                    <small>Start typing to search eSCI Object Codes.</small>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="font-weight-bold">Object Code Instance</label><br/>
                    <input
                        pInputText
                        type="text"
                        [(ngModel)]="objectCodeInstance"
                        [disabled]="isRunning"
                        (input)="onOciInput($event)"
                        maxlength="30"
                        placeholder="Optional — alphanumeric, _ and % only, max 30 characters"
                        style="width: 100%;"/>
                </td>
            </tr>
        }

        <!-- PN: Numeric part number -->
        @if (isPartNumberType()) {
            <tr>
                <td>
                    <label class="font-weight-bold">* Part Number</label><br/>
                    <input
                        pInputText
                        type="text"
                        [(ngModel)]="partNumber"
                        [disabled]="isRunning"
                        (input)="onPartNumberInput($event)"
                        maxlength="10"
                        placeholder="Numeric only — max 10 digits"
                        style="width: 100%;"/>
                    <small>Numeric characters only, max 10.</small>
                </td>
            </tr>
        }

        <!-- CIRCNO: Alphanumeric circuit number -->
        @if (isCircuitType()) {
            <tr>
                <td>
                    <label class="font-weight-bold">* Circuit Number</label><br/>
                    <input
                        pInputText
                        type="text"
                        [(ngModel)]="circuitNumber"
                        [disabled]="isRunning"
                        (input)="onCircuitNumberInput($event)"
                        maxlength="8"
                        placeholder="Alphanumeric — max 8 characters"
                        style="width: 100%;"/>
                    <small>Letters and digits only, max 8.</small>
                </td>
            </tr>
        }

        <tr>
            <td>
                <div class="buttons">
                    <p-button
                        label="Run Report"
                        icon="pi pi-play"
                        class="gm-btn-primary mr-2"
                        (click)="runReport()"
                        [disabled]="isRunning || !permission() || !isFormValid()">
                    </p-button>
                </div>
            </td>
        </tr>
    </table>

    @if (isRunning) {
        <div style="margin-top: 10px;">
            <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
            <small>Capital query in progress. Queries can take up to {{ MAX_POLL_MINUTES }} minutes. Please do not close this page.</small>
        </div>
    }
}
